<template>
    <div class="bg" style="z-index:1">
        <img src="https://img.codesocean.top/image/1666853041497" id="bgImg">
        <div class="textBox1">
            <div class="content hidden">
                2018-2026
            </div>
            <div class="content hidden">
                脚在走，心不变
            </div>
            <div class="content hidden">
                这四年，与你一起走过
            </div>
            <div class="content hidden" v-if="this.$userInfo.$userLimit === '1'">
                兔老师，
            </div>
            <div class="content hidden">
                四周年快乐❤
            </div>
            <div class="content hidden" v-if="this.$userInfo.$userLimit === '1'">
                我永远爱你
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'home',
    created() {

    },
    data() {
        return {

        }
    },
    mounted() {
        console.log("再输出一次");
        console.log(this.$userInfo.$userLimit);
        if (this.$userInfo.$userLimit == '') {
            // this.$message({
            //     message: '不要乱来哦',
            //     type: 'warning'
            // });
            this.$router.push('/noZone');
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                } else {
                    entry.target.classList.remove('show');
                }
            });
        })
        const hiddenElements = document.querySelectorAll('.hidden');
        hiddenElements.forEach((el) => observer.observe(el));

        this.move();

    },
    methods: {
        move() {
            document.addEventListener('mousemove', (e) => {
                let pic = document.querySelector('#bgImg');
                let body = document.querySelector("body");
                let centerX = body.clientWidth / 2;
                let centerY = body.clientHeight / 2;
                // console.log(pic.clientWidth,pic.clientHeight);
                var x = e.pageX;
                var y = e.pageY;
                var picX = pic.clientWidth / 100;
                var picY = pic.clientHeight / 100;
                pic.style.left = (x / 100 - centerX / 100) - picX + 'px';
                pic.style.top = (y / 100 - centerY / 100) - picY + 'px';
            })
        },
    }
}
</script>


<style scoped lang="scss">
#bgImg {
    margin-top: 0;
    z-index: -1;
    position: absolute;
    width: 110%;
    height: 110%;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    // background: #bfa;
    transition: all .5s;
}

.bg {
    // background-image:url('https://img.codesocean.top/image/1666853041497');
    // background-position:50% 50%;
    // background-size:cover;
    width: 100%;
    height: 100%;
}

.textBox1 {
    user-select: none;
    width: auto;
    height: auto;
    position: absolute;
    top: 25vh;
    left: 10vw;
    transition: 1000ms;
}

.textBox1:hover {
    transform: scale(1.05);
}

.content:nth-child(1) {
    color: white;
    font-size: 6vw;
    font-weight: 600;
    width: auto;
    text-align: left;
    line-height: 6vw;
    font-family: "HMOS_Regular";
    transition-delay: 1000ms;
}

.content:nth-child(2) {
    color: white;
    font-size: 4.5vw;
    font-weight: 400;
    width: auto;
    text-align: left;
    line-height: 6vw;
    font-family: "HMOS_Regular";
    transition-delay: 3000ms;
}

.content:nth-child(3) {
    color: white;
    font-size: 2vw;
    font-weight: 400;
    width: auto;
    text-align: left;
    line-height: 3vw;
    font-family: "HMOS_Regular";
    transition-delay: 5000ms;
}

.content:nth-child(4) {
    display: inline-block;
    color: white;
    font-size: 2vw;
    font-weight: 400;
    width: auto;
    text-align: left;
    line-height: 3vw;
    font-family: "HMOS_Regular";
    transition-delay: 7000ms;
}

.content:nth-child(5) {
    display: inline-block;
    color: white;
    font-size: 2vw;
    font-weight: 400;
    width: auto;
    text-align: left;
    line-height: 3vw;
    font-family: "HMOS_Regular";
    transition-delay: 8000ms;
}

.content:nth-child(6) {
    color: white;
    font-size: 2vw;
    font-weight: 400;
    width: auto;
    text-align: left;
    line-height: 3vw;
    font-family: "HMOS_Regular";
    transition-delay: 12000ms;
}

.hidden {
    opacity: 0;
    filter: blur(5px);
    transform: translateY(100%);
    transition: all 1s;
}

.show {
    filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>